import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=ec166e66&"
import script from "./InvoiceView.vue?vue&type=script&lang=js&"
export * from "./InvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports